<template>
	<Transition name="toast">
		<div
			class="toast-message"
			:class="{ 'has-animation': hasAnimation }"
			v-if="showMessage"
			:style="{ width: width, height: height }"
		>
			<p class="toast-message-content" :class="{ uppercase }">
				{{ translatedText ?? translate(`ui.${message}`) }}
			</p>
		</div>
	</Transition>
</template>

<script lang="ts" setup>
import { translate } from "@/utils/translate";

interface Props {
	showMessage: boolean;
	translatedText?: string;
	message?: string;
	uppercase?: boolean;
	width?: string;
	height?: string;
	hasAnimation?: boolean;
}

const {
	showMessage,
	message,
	translatedText,
	uppercase = false,
	width,
	height,
	hasAnimation = false,
} = defineProps<Props>();
</script>

<style scoped lang="scss">
.toast-enter-from,
.toast-leave-to {
	opacity: 0;
}

.toast-leave-to {
	transform: translateY(-2rem);
}

.toast-enter-active,
.toast-leave-active {
	transition: 1s ease all;
}

.toast-message {
	z-index: 1;

	box-shadow: inset 0 0 0.5rem 0 rgba(49, 37, 22, 0.6);
	border: 0.125rem solid rgba($color: #2c2d34, $alpha: 0.6);
	border-radius: 0.2rem;
	background-image: linear-gradient(to top, #d7bd8d, #f2dcb5);
	padding: 0rem 0.5rem;
	&.has-animation {
		animation: flyUp 1s ease-out forwards;
	}
	p {
		margin-bottom: 0.25rem;
		color: #372615;
		font-weight: bold;
		white-space: nowrap;
		&.uppercase {
			text-transform: uppercase;
		}
	}
}
</style>
